// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallBackspace24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M18.2696 19L11.1974 18.9919C10.2441 18.9919 9.42934 18.6985 8.75308 17.9978L3.94591 13.0359C3.40816 12.49 3.17188 11.9929 3.17188 11.4878C3.17188 10.9745 3.41631 10.4856 3.94591 9.93971L8.74493 4.95329C9.41305 4.24443 10.236 4 11.1893 4H18.2696C19.9725 4 20.828 4.83922 20.828 6.5258V16.4742C20.828 18.1608 19.9725 19 18.2696 19ZM18.2534 17.6882C19.0681 17.6882 19.5163 17.2564 19.5163 16.409V6.59098C19.5163 5.74362 19.0681 5.31179 18.2534 5.31179H11.1648C10.5537 5.31179 10.1545 5.41771 9.73081 5.84954L4.96438 10.7952C4.6955 11.0804 4.60588 11.2759 4.60588 11.4878C4.60588 11.6915 4.68736 11.887 4.96438 12.1722L9.73896 17.1016C10.1708 17.5416 10.5537 17.6882 11.173 17.6882H18.2534ZM10.7167 14.9424C10.3582 14.9424 10.0649 14.641 10.0649 14.2825C10.0649 14.1032 10.1301 13.9403 10.2604 13.8262L12.5744 11.5041L10.2604 9.18197C10.1301 9.05975 10.0649 8.90494 10.0649 8.72569C10.0649 8.35904 10.3582 8.08202 10.7167 8.08202C10.8959 8.08202 11.0426 8.13905 11.1648 8.26942L13.4951 10.5915L15.8335 8.26127C15.972 8.12276 16.1186 8.06573 16.2897 8.06573C16.6482 8.06573 16.9416 8.3509 16.9416 8.71755C16.9416 8.8968 16.8764 9.03531 16.746 9.17382L14.4239 11.5041L16.7379 13.818C16.8601 13.9403 16.9334 14.0951 16.9334 14.2825C16.9334 14.641 16.6401 14.9424 16.2816 14.9424C16.0942 14.9424 15.9312 14.8609 15.809 14.7387L13.4951 12.4166L11.1811 14.7387C11.0589 14.8691 10.8959 14.9424 10.7167 14.9424Z" />
			</Svg>
		);
	}
);
SvgCallBackspace24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallBackspace24;
